import VendorRFQ from "./VendorRFQs";
export default VendorRFQ;
